function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1964(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 29.45,
    height: 19.02,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 9.51,
    fontFamily: "Arial"
  }, "\n        Vinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 19.02,
    width: 29.45,
    height: 21.69,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.338
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 29.865000000000002,
    fontFamily: "Arial"
  }, "\n        Noble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 40.71,
    width: 29.45,
    height: 22.36,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.7266666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 51.89,
    fontFamily: "Arial"
  }, "\n        Morgan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 63.06,
    width: 29.45,
    height: 23.74,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.9566666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 74.93,
    fontFamily: "Arial"
  }, "\n        Holmes\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 86.81,
    width: 29.45,
    height: 28.17,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.695
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 100.89500000000001,
    fontFamily: "Arial"
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 114.98,
    width: 29.45,
    height: 32.35,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 131.155,
    fontFamily: "Arial"
  }, "\n        Paulding\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 147.33,
    width: 29.45,
    height: 33.1,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.3625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 163.88000000000002,
    fontFamily: "Arial"
  }, "\n        Pike\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 180.43,
    width: 29.45,
    height: 33.9,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 3.68125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 197.38,
    fontFamily: "Arial"
  }, "\n        Harrison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 214.33,
    width: 29.45,
    height: 36.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 232.57500000000002,
    fontFamily: "Arial"
  }, "\n        Carroll\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 250.82,
    width: 29.45,
    height: 36.49,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 269.065,
    fontFamily: "Arial"
  }, "\n        Adams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 287.31,
    width: 29.45,
    height: 36.74,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.908333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 305.68,
    fontFamily: "Arial"
  }, "\n        Morrow\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 324.05,
    width: 29.45,
    height: 36.92,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 342.51,
    fontFamily: "Arial"
  }, "\n        Hocking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 360.98,
    width: 29.45,
    height: 38.17,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 380.065,
    fontFamily: "Arial"
  }, "\n        Meigs\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 399.14,
    width: 29.45,
    height: 38.34,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.908333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 418.31,
    fontFamily: "Arial"
  }, "\n        Gallia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 437.49,
    width: 29.45,
    height: 39.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 457.21500000000003,
    fontFamily: "Arial"
  }, "\n        Wyandot\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 476.94,
    width: 29.45,
    height: 42.79,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 498.335,
    fontFamily: "Arial"
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 519.73,
    width: 29.45,
    height: 43.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 541.71,
    fontFamily: "Arial"
  }, "\n        Union\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 563.69,
    width: 29.45,
    height: 44.83,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.207142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 586.105,
    fontFamily: "Arial"
  }, "\n        Fayette\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 608.52,
    width: 29.45,
    height: 45.63,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 631.335,
    fontFamily: "Arial"
  }, "\n        Brown\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 654.15,
    width: 29.45,
    height: 45.85,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.89
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 14.725,
    y: 677.0749999999999,
    fontFamily: "Arial"
  }, "\n        Henry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 0,
    width: 34.48,
    height: 41.45,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.746666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 46.69,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 63.93,
    y: 0,
    width: 34.88,
    height: 41.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.976000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 81.37,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Perry\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 98.81,
    y: 0,
    width: 35.75,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.107142857142857
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 116.685,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Jackson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 134.56,
    y: 0,
    width: 36.44,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.073333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 152.78,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 170.99,
    y: 0,
    width: 37.51,
    height: 41.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.3585714285714285
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 189.745,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 208.5,
    y: 0,
    width: 37.6,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.7
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 227.3,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Pickaway\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 246.11,
    y: 0,
    width: 37.9,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.211111111111111
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 265.06,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Champaign\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 284.01,
    y: 0,
    width: 38.72,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.453333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 303.37,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Hardin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 322.73,
    y: 0,
    width: 39.31,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.91375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.385,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Williams\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 362.04,
    y: 0,
    width: 39.51,
    height: 41.45,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.93875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 381.795,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Highland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 401.55,
    y: 0,
    width: 39.94,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.656666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 421.52,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Preble\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 441.49,
    y: 0,
    width: 40.96,
    height: 41.45,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.12
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 461.97,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Defiance\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 482.45,
    y: 0,
    width: 41.36,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.17
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 503.13,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Van_Wert\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 523.81,
    y: 0,
    width: 42.73,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.605555555555556
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 545.175,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Coshocton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 566.54,
    y: 0,
    width: 43.04,
    height: 41.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.908333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 588.06,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Mercer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 609.58,
    y: 0,
    width: 45.17,
    height: 41.45,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.290000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 632.1650000000001,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Logan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 654.75,
    y: 0,
    width: 45.25,
    height: 41.45,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.908333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 677.375,
    y: 20.725,
    fontFamily: "Arial"
  }, "\n        Shelby\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 41.45,
    width: 48.66,
    height: 38.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.451666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 60.80500000000001,
    fontFamily: "Arial"
  }, "\n        Ottawa\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 80.16,
    width: 48.66,
    height: 40.09,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.727142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 100.205,
    fontFamily: "Arial"
  }, "\n        Ashland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 120.24,
    width: 48.66,
    height: 40.42,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.0525
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 140.45,
    fontFamily: "Arial"
  }, "\n        Guernsey\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 160.66,
    width: 48.66,
    height: 41.79,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.22375
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 181.555,
    fontFamily: "Arial"
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 202.46,
    width: 48.66,
    height: 42.08,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.26
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 223.5,
    fontFamily: "Arial"
  }, "\n        Auglaize\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 244.53,
    width: 48.66,
    height: 42.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.121666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 265.895,
    fontFamily: "Arial"
  }, "\n        Athens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 287.26,
    width: 48.66,
    height: 46.77,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.354000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 310.645,
    fontFamily: "Arial"
  }, "\n        Huron\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 334.03,
    width: 48.66,
    height: 46.88,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.72
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 357.46999999999997,
    fontFamily: "Arial"
  }, "\n        Knox\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 380.91,
    width: 48.66,
    height: 50.9,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.866
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 406.36,
    fontFamily: "Arial"
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 431.82,
    width: 48.66,
    height: 51.73,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 457.685,
    fontFamily: "Arial"
  }, "\n        Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 483.55,
    width: 48.66,
    height: 53.12,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 510.11,
    fontFamily: "Arial"
  }, "\n        Crawford\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 536.67,
    width: 48.66,
    height: 53.31,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.732
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 563.3249999999999,
    fontFamily: "Arial"
  }, "\n        Darke\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 589.98,
    width: 48.66,
    height: 54.89,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.11
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 617.4250000000001,
    fontFamily: "Arial"
  }, "\n        Geauga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 29.45,
    y: 644.86,
    width: 48.66,
    height: 55.14,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.0825
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 53.78,
    y: 672.4300000000001,
    fontFamily: "Arial"
  }, "\n        Sandusky\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 41.45,
    width: 49.87,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.4675
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 103.055,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Ross\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 127.99,
    y: 41.45,
    width: 51.73,
    height: 55.26,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.39
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 153.855,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Hancock\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 179.72,
    y: 41.45,
    width: 52.24,
    height: 55.26,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.706666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 205.84,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 231.96,
    y: 41.45,
    width: 53.73,
    height: 55.26,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.955
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 258.825,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 285.69,
    y: 41.45,
    width: 54.62,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.103333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 313,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Marion\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 340.31,
    y: 41.45,
    width: 55.17,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.034
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 367.895,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 395.48,
    y: 41.45,
    width: 55.73,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.209999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 423.345,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Medina\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.21,
    y: 41.45,
    width: 57.96,
    height: 55.26,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 480.19,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 509.17,
    y: 41.45,
    width: 60.52,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.14
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 539.4300000000001,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Fairfield\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 569.69,
    y: 41.45,
    width: 63.54,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.815
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 601.46,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Wood\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 633.23,
    y: 41.45,
    width: 66.77,
    height: 55.26,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.9075
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 666.615,
    y: 69.08,
    fontFamily: "Arial"
  }, "\n        Clermont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 62,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 96.72,
    width: 64.87,
    height: 61.59,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.318000000000001
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 127.515,
    fontFamily: "Arial"
  }, "\n        Miami\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 63,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 158.31,
    width: 64.87,
    height: 61.71,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.8566666666666665
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 189.165,
    fontFamily: "Arial"
  }, "\n        Muskingum\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 64,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 220.02,
    width: 64.87,
    height: 63.91,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.391
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 251.97500000000002,
    fontFamily: "Arial"
  }, "\n        Tuscarawas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 65,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 283.93,
    width: 64.87,
    height: 64.99,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.267142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 316.425,
    fontFamily: "Arial"
  }, "\n        Portage\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 66,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 348.91,
    width: 64.87,
    height: 66.65,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.811666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 382.235,
    fontFamily: "Arial"
  }, "\n        Scioto\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 67,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 415.57,
    width: 64.87,
    height: 68.22,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 10.811666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 449.68,
    fontFamily: "Arial"
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 68,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 483.78,
    width: 64.87,
    height: 70.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.207777777777778
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 519.26,
    fontFamily: "Arial"
  }, "\n        Ashtabula\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 69,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 554.74,
    width: 64.87,
    height: 72.07,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.267142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 590.775,
    fontFamily: "Arial"
  }, "\n        Belmont\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 70,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 78.12,
    y: 626.81,
    width: 64.87,
    height: 73.19,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.267142857142858
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 110.555,
    y: 663.405,
    fontFamily: "Arial"
  }, "\n        Licking\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 71,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 96.72,
    width: 60.04,
    height: 79.96,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.008
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.01000000000002,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Allen\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 72,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 203.02,
    y: 96.72,
    width: 67.36,
    height: 79.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.42
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 236.70000000000002,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Richland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 73,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.39,
    y: 96.72,
    width: 68.75,
    height: 79.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304.765,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Columbiana\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 74,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 339.14,
    y: 96.72,
    width: 69.2,
    height: 79.96,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.688888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 373.74,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 75,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 408.34,
    y: 96.72,
    width: 82.42,
    height: 79.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.991999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.54999999999995,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Clark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 76,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 490.77,
    y: 96.72,
    width: 95.46,
    height: 79.96,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 19.99
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 538.5,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Lake\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 77,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 586.23,
    y: 96.72,
    width: 113.77,
    height: 79.96,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 13.326666666666666
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 643.115,
    y: 136.7,
    fontFamily: "Arial"
  }, "\n        Butler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 78,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 176.68,
    width: 101.65,
    height: 98.86,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.3575
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.815,
    y: 226.11,
    fontFamily: "Arial"
  }, "\n        Trumbull\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 79,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 275.54,
    width: 101.65,
    height: 100.12,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 16.686666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.815,
    y: 325.6,
    fontFamily: "Arial"
  }, "\n        Lorain\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 80,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 375.67,
    width: 101.65,
    height: 151.46,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.70625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.815,
    y: 451.40000000000003,
    fontFamily: "Arial"
  }, "\n        Mahoning\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 81,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.99,
    y: 527.13,
    width: 101.65,
    height: 172.87,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.330000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 193.815,
    y: 613.565,
    fontFamily: "Arial"
  }, "\n        Stark\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 82,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.63,
    y: 176.68,
    width: 142.31,
    height: 161.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 28.462
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 315.78499999999997,
    y: 257.31,
    fontFamily: "Arial"
  }, "\n        Lucas\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 83,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.94,
    y: 176.68,
    width: 152.05,
    height: 161.26,
    style: {
      fill: "#86B6F2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 15.205000000000002
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 462.96500000000003,
    y: 257.31,
    fontFamily: "Arial"
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 84,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 538.99,
    y: 176.68,
    width: 161.01,
    height: 161.26,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 26.834999999999997
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 619.495,
    y: 257.31,
    fontFamily: "Arial"
  }, "\n        Summit\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 85,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.63,
    y: 337.94,
    width: 220.32,
    height: 160.18,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.0225
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.78999999999996,
    y: 418.03,
    fontFamily: "Arial"
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 86,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 244.63,
    y: 498.12,
    width: 220.32,
    height: 201.88,
    style: {
      fill: "#ABD3FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 25.235
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 354.78999999999996,
    y: 599.06,
    fontFamily: "Arial"
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 87,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 464.96,
    y: 337.94,
    width: 235.04,
    height: 362.06,
    style: {
      fill: "#1666CB"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 29.38
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 582.48,
    y: 518.97,
    fontFamily: "Arial"
  }, "\n        Cuyahoga\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1964);
export default __webpack_public_path__ + "static/media/1964.8149c00eaf2a1067110e8df25a2c969c.svg";
export { ForwardRef as ReactComponent };